export const links = {
  contact: '/call-design-team',
  work: '/work',
  approach: '/web-app-design-approach',
  whoWeAre: '/design-architects'
  // blog: 'design-studio-blog'
}
